<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <ChangePassword :id="customer_id" />
    <div class="container">
      <div class="row">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
          <v-btn class="btn-return" v-on:click="handleToBack">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
          </v-btn>
        </div>
        <div class="col-xl-11 col-lg-10 col-md-10 col-sm-9 col-12 pt-0">
          <h3 class="title-pages pt-1">{{ name }}</h3>
        </div>
      </div>
      <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <a
            @click="errors = []"
            class="nav-link active link-annotation-care"
            id="nav-informacoes"
            data-toggle="tab"
            href="#informacoes"
            role="tab"
            aria-controls="informacoes"
            aria-selected="true"
            >INFORMAÇÕES</a
          >
          <a
            @click="errors = []"
            class="nav-link link-annotation-care"
            id="nav-documentos"
            data-toggle="tab"
            href="#documentos"
            role="tab"
            aria-controls="documentos"
            aria-selected="false"
            >DOCUMENTOS</a
          >
          <a
            @click="errors = []"
            class="nav-link link-annotation-care"
            id="nav-informacoes-endereco"
            data-toggle="tab"
            href="#informacoes-endereco"
            role="tab"
            aria-controls="informacoes-endereco"
            aria-selected="false"
            >ENDEREÇO</a
          >
          <a
            @click="errors = []"
            class="nav-link link-annotation-care"
            id="nav-residentes"
            data-toggle="tab"
            href="#residentes"
            role="tab"
            aria-controls="residentes"
            aria-selected="false"
            >RESIDENTES</a
          >
          <!-- <a
            @click="errors = []"
            class="nav-link link-annotation-care"
            id="nav-status"
            data-toggle="tab"
            href="#status"
            role="tab"
            aria-controls="status"
            aria-selected="false"
            >ACESSO AO SISTEMA</a
          > -->
        </div>
      </nav>
      <b-overlay :show="loading" opacity="0.99">
        <div class="tab-content">
          <div
            class="tab-pane fade show active"
            id="informacoes"
            role="tabpanel"
            aria-labelledby="nav-informacoes"
          >
            <WarningMessage
              v-if="!permission('edit', 'resident_relatives')"
              message="Você não tem permissão para modificar familiares"
            />
            <div class="row pt-3">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pb-0">
                <v-text-field
                  :disabled="!permission('edit', 'resident_relatives')"
                  v-model="name"
                  label="Nome"
                  outlined
                  dense
                />
              </div>
              <div class="col-xl-2 col-lg-2 col-md-3 col-sm-6 col-12 pb-0">
                <v-select
                  :disabled="!permission('edit', 'resident_relatives')"
                  v-model="type_of_customer_id"
                  :items="typesOfCustomer"
                  label="Grau de parentesco"
                  dense
                  outlined
                  item-value="id"
                  item-text="name"
                />
              </div>
              <div class="col-xl-2 col-lg-2 col-md-3 col-sm-6 col-12 pb-0">
                <v-text-field
                  :disabled="!permission('edit', 'resident_relatives')"
                  v-mask="'(##) # ####-####'"
                  v-model="first_phone"
                  label="1º Telefone"
                  outlined
                  dense
                />
              </div>
              <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12 pb-0">
                <v-text-field
                  :disabled="!permission('edit', 'resident_relatives')"
                  v-mask="'(##) # ####-####'"
                  v-model="second_phone"
                  label="2º Telefone"
                  outlined
                  dense
                />
              </div>
              <div class="col-xl-2 col-lg-2 col-md-3 col-sm-6 col-12 pb-0">
                <v-text-field
                  :disabled="!permission('edit', 'resident_relatives')"
                  type="date"
                  v-model="date_of_birth"
                  label="Data de nascimento"
                  outlined
                  dense
                />
                <h6 class="m-0">
                  {{
                    date_of_birth && date_of_birth.length == 10
                      ? "Idade: " +
                        getAge(formatDateToUs(date_of_birth, true)) +
                        " anos"
                      : ""
                  }}
                </h6>
              </div>
              <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12 pb-0">
                <v-select
                  :disabled="!permission('edit', 'resident_relatives')"
                  v-model="gender_id"
                  :items="genders"
                  label="Gênero"
                  dense
                  outlined
                  item-value="id"
                  item-text="name"
                />
              </div>
              <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12 pb-0">
                <v-select
                  :disabled="!permission('edit', 'resident_relatives')"
                  v-model="marital_status_id"
                  :items="maritalStatus"
                  label="Estado civil"
                  dense
                  outlined
                  item-value="id"
                  item-text="name"
                />
              </div>
              <div class="col-xl-2 col-lg-2 col-md-3 col-sm-6 col-12 pb-0">
                <v-text-field
                  :disabled="!permission('edit', 'resident_relatives')"
                  type="text"
                  v-model="ie"
                  label="IE"
                  outlined
                  dense
                />
              </div>
              <div class="col-md-4 pb-0">
                <v-select
                  :disabled="!permission('edit', 'resident_relatives')"
                  v-model="status"
                  :items="[{ name: 'ATIVO' }, { name: 'INATIVO' }]"
                  label="Status"
                  dense
                  outlined
                  item-value="name"
                  item-text="name"
                />
              </div>
              <div class="col-md-12">
                <v-text-field
                  :disabled="!permission('edit', 'resident_relatives')"
                  type="email"
                  v-model="email"
                  label="E-mail"
                  outlined
                  dense
                />
              </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <WarningRequiredFields
                v-if="permission('edit', 'resident_relatives')"
              />
              <ErrorsMessages :errors="errors" />
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div class="row">
                <div class="col-md-6">
                  <h6 class="worksansr">
                    Criação:
                    {{ formatDate(created_at) }}
                  </h6>
                  <h6 class="worksansr">
                    Última alteração:
                    {{ formatDate(updated_at) }}
                  </h6>
                </div>
                <div class="col-md-6 text-right">
                  <v-btn
                    v-if="permission('read', 'resident')"
                    type="button"
                    @click="handlePrint"
                    class="btn-print m-1"
                  >
                    <i class="fas fa-print mr-2 text-twenty"></i>
                    IMPRIMIR
                  </v-btn>

                  <confirmation-dialog
                    v-if="permission('edit', 'resident_relatives')"
                    message-title="EXCLUIR"
                    message-body="Deseja realmente excluir o familiar?"
                    open-class="btn-delete m-1"
                    open-left-icon="fa-trash"
                    open-text="EXCLUIR"
                    @yes="deleteCustomer()"
                  />

                  <v-btn-timeout
                    v-if="permission('edit', 'resident_relatives')"
                    :disabled="loadingUpdate"
                    @click="update"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="documentos"
            role="tabpanel"
            aria-labelledby="nav-documentos"
          >
            <div class="row pt-3">
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 pb-0">
                <VTextFieldCPF
                  :disabled="!permission('edit', 'resident_relatives')"
                  v-mask="'###.###.###-##'"
                  v-model="cpf"
                />
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 pb-0">
                <v-text-field
                  :disabled="!permission('edit', 'resident_relatives')"
                  v-model="rg"
                  label="RG"
                  outlined
                  dense
                />
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 pb-0">
                <v-text-field
                  :disabled="!permission('edit', 'resident_relatives')"
                  v-model="issuing_body"
                  label="Orgão expedidor"
                  outlined
                  dense
                />
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 pb-0">
                <v-text-field
                  :disabled="!permission('edit', 'resident_relatives')"
                  type="date"
                  v-model="date_of_issue"
                  label="Data de emissão"
                  outlined
                  dense
                />
              </div>
              <div class="col-md-12"><ErrorsMessages :errors="errors" /></div>
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right"
              >
                <v-btn-timeout
                  v-if="permission('edit', 'resident_relatives')"
                  :disabled="loadingUpdate"
                  @click="update"
                />
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="informacoes-endereco"
            role="tabpanel"
            aria-labelledby="nav-informacoes-endereco"
          >
            <div class="row pt-3">
              <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12">
                <VTextFieldCEP
                  :disabled="!permission('edit', 'resident_relatives')"
                  v-model="cep"
                  @retrieved="evOnCEPRetrieved"
                />
              </div>
              <div class="col-xl-8 col-lg-8 col-md-6 col-sm-6 col-12">
                <v-text-field
                  :disabled="!permission('edit', 'resident_relatives')"
                  v-model="address"
                  label="Endereço"
                  outlined
                  dense
                />
              </div>
              <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-12">
                <v-text-field
                  :disabled="!permission('edit', 'resident_relatives')"
                  v-model="number_address"
                  label="Nº"
                  outlined
                  dense
                />
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                <v-text-field
                  :disabled="!permission('edit', 'resident_relatives')"
                  v-model="neighborhood"
                  label="Bairro"
                  outlined
                  dense
                />
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                <v-text-field
                  :disabled="!permission('edit', 'resident_relatives')"
                  v-model="city"
                  label="Cidade"
                  outlined
                  dense
                />
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                <v-select
                  :disabled="!permission('edit', 'resident_relatives')"
                  v-model="uf_id"
                  :items="ufs"
                  label="Estado"
                  dense
                  outlined
                  item-value="id"
                  item-text="name"
                />
              </div>
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right"
              >
                <v-btn-timeout
                  v-if="permission('edit', 'resident_relatives')"
                  :disabled="loadingUpdate"
                  @click="update"
                />
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="residentes"
            role="tabpanel"
            aria-labelledby="nav-residentes"
          >
            <CustomerHasResident :customer_id="customer_id" />
          </div>
          <div
            class="tab-pane fade"
            id="status"
            role="tabpanel"
            aria-labelledby="nav-status"
          >
            <div class="row pt-3">
              <div class="col-md-12 pt-0 pb-0">
                <v-text-field
                  :disabled="!permission('edit', 'resident_relatives')"
                  type="email"
                  v-model="email"
                  label="E-mail"
                  outlined
                  dense
                />
              </div>
              <div class="col-md-12 pt-0 pb-0">
                <ErrorsMessages :errors="errors" />
              </div>
              <div class="col-md-12 pt-0 pb-0 text-right">
                <!-- <v-btn
                  v-if="permission('edit', 'resident_relatives')"
                  class="btn-print m-1"
                  @click="$bvModal.show('change_password')"
                >
                  <i class="fas fa-lock mr-2 text-twenty"></i> ALTERAR SENHA
                </v-btn> -->
                <v-btn-timeout
                  v-if="permission('edit', 'resident_relatives')"
                  :timeout="timeout"
                  :disabled="loadingUpdate"
                  @click="update"
                />
              </div>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import WarningMessage from "../templates/Components/WarningMessage";
import WarningRequiredFields from "../templates/Components/WarningRequiredFields";
import VBtnTimeout from "../templates/Components/VBtnTimeout";

import VTextFieldCEP from "../templates/Components/VTextFieldCEP.vue";

import VTextFieldCPF from "../templates/Components/VTextFieldCPF.vue";

import CustomerHasResident from "../templates/Customer/Resident";

import ChangePassword from "../templates/Customer/Password";

import api from "../services/api";

import toast from "../lib/ToastNotification";

import permission from "../lib/permission";

import { formatDate, formatDateToUs } from "../lib/format";

import { getAge } from "../lib/getAgeByDate";

import routes from "../routes";

import { getStatic } from "../lib/functions";

import ConfirmationDialog from "../templates/Components/ConfirmationDialog";

export default {
  name: "Customer",

  components: {
    NavBar,
    CustomerHasResident,
    ChangePassword,
    AuthBySessionExpired,
    ErrorsMessages,
    WarningMessage,
    WarningRequiredFields,
    VBtnTimeout,
    VTextFieldCEP,
    VTextFieldCPF,
    ConfirmationDialog,
  },

  data() {
    return {
      errors: [],
      search: "",
      timeout: 30,
      stepCustomer: 1,
      customers: [],
      typesOfCustomer: [],
      maritalStatus: [],
      genders: [],
      ufs: [],
      customer_id: "",
      type_of_customer_id: "",
      gender_id: "",
      marital_status_id: "",
      uf_id: "",
      name: "",
      kinship: "",
      rg: "",
      cpf: "",
      issuing_body: "",
      date_of_issue: "",
      first_phone: "",
      second_phone: "",
      email: "",
      date_of_birth: "",
      cep: "",
      address: "",
      number_address: "",
      complement: "",
      city: "",
      neighborhood: "",
      ie: "",
      status: "ATIVO",
      loadingCreate: false,
      loadingUpdate: false,
      loading: true,
      created_at: "",
      updated_at: "",
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,
    getAge,
    formatDate,
    formatDateToUs,

    async evOnCEPRetrieved(value) {
      this.cep = value.cep;
      this.city = value.localidade || this.city;
      this.neighborhood = value.bairro || this.neighborhood;
      // this.complement = value.complemento || this.complement;
      this.address = value.logradouro || this.address;

      const matched_uf = this.ufs.find(
        (item) => item.initials.toLowerCase() === value.uf.toLowerCase()
      );
      if (matched_uf) this.uf_id = matched_uf.id;
    },

    async retrieve() {
      const { id } = routes.history.current.params;

      this.customer_id = id;

      await this.get();

      try {
        this.ufs = (await getStatic("/ufs", true)).ufs;
        this.genders = (await getStatic("/genders", true)).genders;
        this.maritalStatus = (
          await getStatic("/rest-home/marital-status/all", true)
        ).marital_status;
        this.typesOfCustomer = (
          await getStatic("/types-of-customers", true)
        ).types;
      } catch (errors) {
        this.errors = errors;
      }
    },

    async update() {
      try {
        this.loadingUpdate = true;
        this.timeout = 30;

        const {
          customer_id,
          type_of_customer_id,
          gender_id,
          marital_status_id,
          uf_id,
          name,
          kinship,
          first_phone,
          second_phone,
          email,
          date_of_birth,
          rg,
          cpf,
          issuing_body,
          date_of_issue,
          cep,
          address,
          number_address,
          city,
          neighborhood,
          ie,
          status,
        } = this;

        let params = {
          id: customer_id,
          type_of_customer_id,
          gender_id,
          marital_status_id,
          uf_id,
          name,
          first_phone,
          second_phone,
          email,
          date_of_birth,
          kinship,
          rg,
          cpf,
          issuing_body,
          date_of_issue,
          cep,
          address,
          number_address,
          city,
          neighborhood,
          ie,
          status,
        };

        const response = await api.patch("/rest-home/customer/", params);

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.errors = [];
        } else {
          this.errors = errors;
          this.timeout = 0;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },

    async get() {
      try {
        this.stepCustomer = 1;

        this.loading = true;

        const { customer_id } = this;

        const response = await api.get("/rest-home/customer", {
          params: { id: customer_id },
        });

        const { customer, error } = response.data;

        if (error) {
          return routes.push({ name: "customers" });
        }

        this.type_of_customer_id = customer.type_of_customer_id;

        if (customer.gender_id) {
          this.gender_id = customer.gender_id;
        } else {
          this.gender_id = "";
        }

        if (customer.marital_status_id) {
          this.marital_status_id = customer.marital_status_id;
        } else {
          this.marital_status_id = "";
        }

        if (customer.uf_id) {
          this.uf_id = customer.uf_id;
        } else {
          this.uf_id = "";
        }

        this.name = customer.name;
        this.kinship = customer.kinship;
        this.rg = customer.rg;
        this.cpf = customer.cpf;
        this.issuing_body = customer.issuing_body;
        this.date_of_issue = formatDateToUs(customer.date_of_issue);
        this.first_phone = customer.first_phone;
        this.second_phone = customer.second_phone;
        this.email = customer.email;
        this.date_of_birth = formatDateToUs(customer.date_of_birth);
        this.cep = customer.cep;
        this.address = customer.address;
        this.number_address = customer.number_address;
        this.city = customer.city;
        this.neighborhood = customer.neighborhood;
        this.ie = customer.ie;
        this.status = customer.status == 1 ? "ATIVO" : "INATIVO";
        this.created_at = customer.created_at;
        this.updated_at = customer.updated_at;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deleteCustomer() {
      try {
        this.loading = true;

        const data = { id: this.customer_id };

        const response = await api.delete("/rest-home/customer", {
          data,
        });

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];

          toast(message, "success");

          this.$router.push({
            name: "customers",
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    handlePrint() {
      const { customer_id: id } = this;

      let route = this.$router.resolve({
        name: "print_customer",
        params: {
          id,
        },
      });

      window.open(route.href, "_blank");
    },

    handleToBack: () => routes.go(-1),
  },
};
</script>